import { RmaIcons } from '@rma/generic/ui/icon';

export const sectionIconNameMap: { [key: string]: RmaIcons } = {
  listings: 'cottage',
  marketing: 'show_chart',
  'my profile': 'account_circle',
  reviews: 'rma-reviews',
  settings: 'settings',
};
